import * as Yup from "yup";

export const table = {
  primaryData: [
    {
        title: "ID",
        value: "id",
        type: "configue",
    },
    {
        title: " Name",
        value: "name",
        type: "configue",
    },
    {
        title: "Description",
        value: "description",
        type: "configue",
    },
    { 
       title: "Capabilities",
        value: "capabilities",
        type: "configue",

    },
    {
        title: "Created At",
        value: "createdAt",
        type: "configue",
    },
    {
        title: "Updated At",
        value: "updatedAt",
        type: "configue",
        name: "updatedAt"
    },
    {
        title: "Created By",
        value: "createdByName",
        type: "configue"
    },
    {
        title: "Updated By",
        value: "updatedByName",
        type: "configue",
        name: "updatedByName"
    }
    
  ],
  secondaryData: [],
};

export type vendors = {
    id: string;
    name: string;
    description: string;
    capabilities: string;
    createdAt: string;
    updatedAt: string;
    createdById: string;
    updatedById: string;
    createdByName: string;
    updatedByName: string;
};

export const vendorsInitialValues: vendors = {
  id: "",
  name: "",
  description: "",
  capabilities: "",
  createdAt: "",
  updatedAt: "",
  createdById: "",
  updatedById: "",
  createdByName: "",
  updatedByName: "",
};

export const vendorsMandatoryFields = [{ id: "name" }];

export const vendorsValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
});

export const vendorsProperties = [
  {
    id: "ID",
    type: "text",
    label: `ID`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "Name",
    type: "text",
    label: `Vendor Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "Description",
    type: "text",
    label: `Description`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "Capabilities",
    type: "text",
    label: `Capabilities`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "createdAt",
    type: "date-picker",
    label: `Created At`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updatedAt",
    type: "date-picker",
    label: `Updated At`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "createdById",
    type: "text",
    label: `Created By Id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updatedById",
    type: "text",
    label: `Updated By Id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "createdByName",
    type: "text",
    label: `Created By Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updatedByName",
    type: "text",
    label: `Updated By Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  }
];